export const SectionTitle: React.FC<{
  children: string;
  id: string;
}> = props => (
  <h2 id={props.id} style={{ marginLeft: '0em', textDecoration: 'underline' }}>
    {props.children}
  </h2>
);
